import React from 'react'
import Link from 'next/link'
import {
  useGblLocationsByState,
  type GblLocationRow,
} from './useGblLocationsByState'

export const LocationsFooter = () => {
  const stateLocationMap = useGblLocationsByState('LocationsFooter')

  return (
    <footer className="w-full bg-navy text-white py-12">
      <div className="container mx-auto px-4">
        {/* Locations Section */}
        <div className="mb-10">
          <h3 className="text-gray-400 font-medium mb-6 uppercase tracking-wider">
            CONSULTATION LOCATIONS
          </h3>
          <p className="!text-gray-300 mb-12 max-w-3xl">
            We can provide service at your location, or visit us inside Valvoline
            for a consultation
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {(Object.entries(stateLocationMap) as [string, GblLocationRow[]][]).map(
              ([state, cities]) => (
              <div key={state}>
                <h4 className="text-white font-medium mb-3">{state}</h4>
                <ul className="space-y-2 text-gray-700 p-0">
                  {cities.map((city) => (
                    <li
                      key={`${city.city}-${city.storeID}`}
                      className="list-none m-0 p-0 !text-gray-400 hover:text-primary transition-colors text-sm"
                    >
                      <Link
                        href={`/locations/${city.slug.replace(/^\/+/, '')}`}
                        className="!text-gray-400 hover:text-primary transition-colors text-sm"
                      >
                        <a className="!text-gray-400 hover:text-primary transition-colors text-sm">
                          {city.name} Store #{city.storeID}
                        </a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
